// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Main_wrap__left__1N4hZ {
  position: relative;
  margin-top: 40px;
  height: fit-content;
}
.Main_wrap__left__1N4hZ h1 {
  display: inline;
  font-size: 85px;
  font-weight: 400;
  line-height: 90px;
  letter-spacing: -1.8px;
  max-width: 600px;
}
.Main_wrap__left__inline__rV9uI {
  transition: 0.35s ease;
  position: relative;
  display: flex;
  column-gap: 15px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
}
.Main_wrap__left__inline__rV9uI .Main_circle__in__tAMtt {
  width: 48px;
  height: 48px;
  border: 3.67px solid #000;
  display: flex;
  transition: 0.35s ease;
  justify-content: center;
  border-radius: 100%;
}
.Main_wrap__left__inline__rV9uI .Main_circle__xHJrA svg {
  margin-left: 2px;
}
.Main_wrap__left__inline__rV9uI .Main_arrow__8vZqe {
  transition: 0.35s ease;
}
.Main_wrap__left__inline__rV9uI:hover .Main_circle__in__tAMtt, .Main_wrap__left__inline__rV9uI:active .Main_circle__in__tAMtt {
  border-color: #ff6f19;
}
.Main_wrap__left__inline__rV9uI:hover .Main_circle__xHJrA svg, .Main_wrap__left__inline__rV9uI:active .Main_circle__xHJrA svg {
  margin-left: 2px;
}
.Main_wrap__left__inline__rV9uI:hover .Main_arrow__8vZqe, .Main_wrap__left__inline__rV9uI:active .Main_arrow__8vZqe {
  color: #ff6f19;
}
.Main_wrap__left__inline__rV9uI:hover button, .Main_wrap__left__inline__rV9uI:active button {
  background-color: #ff6f19;
}
.Main_wrap__left__inline__wrap__dzQA\\+ {
  position: absolute;
  right: 16px;
  bottom: 5px;
}
.Main_wrap__right__img__Nsvlt {
  width: 485px;
  height: 383px;
  border-radius: 50px;
  background-size: cover;
  background-position: center;
}

.Main_underTitle__4iNGg {
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 31px; /* 155% */
  letter-spacing: -0.4px;
}

@media (max-width: 1200px) {
  .Main_wrap__Sz3qQ {
    flex-direction: column;
    row-gap: 2rem;
  }
  .Main_wrap__left__1N4hZ {
    margin-top: 0;
  }
  .Main_wrap__left__1N4hZ h1 {
    font-size: 62px;
    line-height: 64px;
    font-weight: 400;
    display: flex;
    text-align: center;
    width: 100%;
    max-width: 100%;
    justify-content: center;
  }
  .Main_wrap__right__img__Nsvlt {
    width: 100%;
  }
}
@media (max-width: 728px) {
  .Main_wrap__right__yfLlN {
    width: 100%;
  }
  .Main_wrap__right__img__Nsvlt {
    height: 250px;
    width: 100%;
  }
  .Main_wrap__left__1N4hZ h1 {
    font-size: 45px;
    line-height: 48px;
    font-weight: 400;
    max-width: 90vw;
    display: block;
    word-break: normal;
    overflow-wrap: normal;
    white-space: normal;
    text-align: center;
    margin: 0 auto;
  }
  .Main_wrap__left__inline__rV9uI {
    margin-top: 2rem;
  }
  .Main_wrap__left__inline__rV9uI .Main_circle__xHJrA {
    display: none;
  }
  .Main_wrap__left__inline__wrap__dzQA\\+ {
    position: relative;
    bottom: auto;
    right: auto;
    margin-top: 0;
  }
  .Main_wrap__right__img__Nsvlt {
    max-width: 545px;
  }
  .Main_underTitle__4iNGg {
    font-size: 18px;
    line-height: 22px;
  }
}
.Main_under__photo__RquAe {
  max-width: 485px;
  width: 100%;
  border-radius: 30px;
}
.Main_under__photo__RquAe h4 {
  border-radius: 30px;
}
.Main_under__photo__deliv__imCEZ {
  border-radius: 30px;
  color: #000;
}

@media (max-width: 1145px) {
  .Main_under__photo__RquAe {
    max-width: 100%;
    width: 100%;
  }
  .Main_under__photo__RquAe h4 {
    width: 100%;
    text-align: center;
    line-height: 60px;
  }
}
@media (max-width: 728px) {
  .Main_under__photo__RquAe h4 {
    font-size: 18px;
    line-height: 31px;
  }
  .Main_under__photo__RquAe svg {
    max-height: 20px;
  }
}
@media (max-width: 360px) {
  .Main_under__photo__RquAe svg {
    max-height: 15px;
  }
  .Main_under__photo__RquAe h4 {
    font-size: 18px;
    line-height: 20px;
  }
}
@media (max-width: 321px) {
  .Main_wrap__left__1N4hZ h1 {
    font-size: 35px;
    line-height: 38px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/screens/main/Main.module.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAGC;EACC,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;AAGE;EACC,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AADH;AAIE;EACC,sBCbE;EDcF,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AAFH;AAKI;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,sBC3BA;ED6BA,uBAAA;EACA,mBAAA;AAHL;AAMI;EACC,gBAAA;AAJL;AAQG;EACC,sBCvCC;ADiCL;AAYK;EACC,qBClDG;ADwCT;AAaK;EACC,gBAAA;AAXN;AAeI;EACC,cC3DI;AD8CT;AAgBI;EACC,yBC/DI;ADiDT;AAkBG;EACC,kBAAA;EACA,WAAA;EACA,WAAA;AAhBJ;AAsBE;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;AApBH;;AAyBA;EACC,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,sBAAA;AAtBD;;AAyBA;EACC;IACC,sBAAA;IACA,aAAA;EAtBA;EAwBA;IACC,aAAA;EAtBD;EAwBC;IACC,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,aAAA;IACA,kBAAA;IACA,WAAA;IACA,eAAA;IACA,uBAAA;EAtBF;EA2BC;IACC,WAAA;EAzBF;AACF;AA8BA;EACC;IACC,WAAA;EA5BA;EA+BD;IACC,aAAA;IACA,WAAA;EA7BA;EAkCC;IACC,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,eAAA;IACA,cAAA;IACA,kBAAA;IACA,qBAAA;IACA,mBAAA;IACA,kBAAA;IACA,cAAA;EAhCF;EAkCC;IACC,gBAAA;EAhCF;EAiCE;IACC,aAAA;EA/BH;EAkCE;IACC,kBAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;EAhCH;EAsCC;IACC,gBAAA;EApCF;EAyCD;IACC,eAAA;IACA,iBAAA;EAvCA;AACF;AA0CA;EACC,gBAAA;EACA,WAAA;EACA,mBAAA;AAxCD;AA0CC;EACC,mBAAA;AAxCF;AA2CC;EACC,mBAAA;EACA,WAAA;AAzCF;;AA6CA;EACC;IACC,eAAA;IACA,WAAA;EA1CA;EA4CA;IACC,WAAA;IACA,kBAAA;IACA,iBAAA;EA1CD;AACF;AA8CA;EAEE;IACC,eAAA;IACA,iBAAA;EA7CD;EAgDA;IACC,gBAAA;EA9CD;AACF;AAoDA;EAEE;IACC,gBAAA;EAnDD;EAsDA;IACC,eAAA;IACA,iBAAA;EApDD;AACF;AAyDA;EAGG;IACC,eAAA;IACA,iBAAA;EAzDF;AACF","sourcesContent":["@import '../../../variables';\n\n.wrap {\n\t&__left {\n\t\tposition: relative;\n\t\tmargin-top: 40px;\n\t\theight: fit-content;\n\t\th1 {\n\t\t\tdisplay: inline;\n\t\t\tfont-size: 85px;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 90px;\n\t\t\tletter-spacing: -1.8px;\n\t\t\tmax-width: 600px;\n\t\t}\n\n\t\t&__inline {\n\t\t\ttransition: $tr;\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\tcolumn-gap: 15px;\n\t\t\tcursor: pointer;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\n\t\t\t.circle {\n\t\t\t\t&__in {\n\t\t\t\t\twidth: 48px;\n\t\t\t\t\theight: 48px;\n\t\t\t\t\tborder: 3.67px solid $dark;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\ttransition: $tr;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tborder-radius: 100%;\n\t\t\t\t}\n\n\t\t\t\tsvg {\n\t\t\t\t\tmargin-left: 2px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.arrow {\n\t\t\t\ttransition: $tr;\n\t\t\t}\n\n\t\t\t&:hover,\n\t\t\t&:active {\n\t\t\t\t.circle {\n\t\t\t\t\t&__in {\n\t\t\t\t\t\tborder-color: $accent;\n\t\t\t\t\t}\n\n\t\t\t\t\tsvg {\n\t\t\t\t\t\tmargin-left: 2px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.arrow {\n\t\t\t\t\tcolor: $accent;\n\t\t\t\t}\n\n\t\t\t\tbutton {\n\t\t\t\t\tbackground-color: $accent;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&__wrap {\n\t\t\t\tposition: absolute;\n\t\t\t\tright: 16px;\n\t\t\t\tbottom: 5px;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__right {\n\t\t&__img {\n\t\t\twidth: 485px;\n\t\t\theight: 383px;\n\t\t\tborder-radius: 50px;\n\t\t\tbackground-size: cover;\n\t\t\tbackground-position: center;\n\t\t}\n\t}\n}\n\n.underTitle {\n\tfont-size: 20px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 31px; /* 155% */\n\tletter-spacing: -0.4px;\n}\n\n@media (max-width: 1200px) {\n\t.wrap {\n\t\tflex-direction: column;\n\t\trow-gap: 2rem;\n\n\t\t&__left {\n\t\t\tmargin-top: 0;\n\n\t\t\th1 {\n\t\t\t\tfont-size: 62px;\n\t\t\t\tline-height: 64px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tdisplay: flex;\n\t\t\t\ttext-align: center;\n\t\t\t\twidth: 100%;\n\t\t\t\tmax-width: 100%;\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t}\n\n\t\t&__right {\n\t\t\t&__img {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 728px) {\n\t.wrap__right {\n\t\twidth: 100%;\n\t}\n\n\t.wrap__right__img {\n\t\theight: 250px;\n\t\twidth: 100%;\n\t}\n\n\t.wrap {\n\t\t&__left {\n\t\t\th1 {\n\t\t\t\tfont-size: 45px;\n\t\t\t\tline-height: 48px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tmax-width: 90vw;\n\t\t\t\tdisplay: block;\n\t\t\t\tword-break: normal;\n\t\t\t\toverflow-wrap: normal;\n\t\t\t\twhite-space: normal;\n\t\t\t\ttext-align: center;\n\t\t\t\tmargin: 0 auto;\n\t\t\t}\n\t\t\t&__inline {\n\t\t\t\tmargin-top: 2rem;\n\t\t\t\t.circle {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\n\t\t\t\t&__wrap {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tbottom: auto;\n\t\t\t\t\tright: auto;\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&__right {\n\t\t\t&__img {\n\t\t\t\tmax-width: 545px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.underTitle {\n\t\tfont-size: 18px;\n\t\tline-height: 22px;\n\t}\n}\n\n.under__photo {\n\tmax-width: 485px;\n\twidth: 100%;\n\tborder-radius: 30px;\n\n\th4 {\n\t\tborder-radius: 30px;\n\t}\n\n\t&__deliv {\n\t\tborder-radius: 30px;\n\t\tcolor: #000;\n\t}\n}\n\n@media (max-width: 1145px) {\n\t.under__photo {\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\n\t\th4 {\n\t\t\twidth: 100%;\n\t\t\ttext-align: center;\n\t\t\tline-height: 60px;\n\t\t}\n\t}\n}\n\n@media (max-width: 728px) {\n\t.under__photo {\n\t\th4 {\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 31px;\n\t\t}\n\n\t\tsvg {\n\t\t\tmax-height: 20px;\n\t\t}\n\t}\n}\n\n\n\n@media (max-width: 360px) {\n\t.under__photo {\n\t\tsvg {\n\t\t\tmax-height: 15px;\n\t\t}\n\n\t\th4 {\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 20px;\n\t\t}\n\t}\n}\n\n\n@media (max-width: 321px) {\n\t\t.wrap {\n\t\t&__left {\n\t\t\th1 {\n\t\t\t\tfont-size: 35px;\n\t\t\t\tline-height: 38px;\n\t\t\t}\n\t\t}\n\t}\n}","$accent: #ff6f19;\n$grey: #eaeaea;\n$w: #fff;\n$dark: #000;\n$tr: 0.35s ease;\n$br40: 40px;\n$Jost: 'Jost-Regular';\n$Jost300: 'Jost-Light';\n$Jost500: 'Jost-Medium';\n$Jost600: 'Jost-SemiBold';\n$Jost700: 'Jost-Bold';\n$Jost800: 'Jost-ExtraBold';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap__left": `Main_wrap__left__1N4hZ`,
	"wrap__left__inline": `Main_wrap__left__inline__rV9uI`,
	"circle__in": `Main_circle__in__tAMtt`,
	"circle": `Main_circle__xHJrA`,
	"arrow": `Main_arrow__8vZqe`,
	"wrap__left__inline__wrap": `Main_wrap__left__inline__wrap__dzQA+`,
	"wrap__right__img": `Main_wrap__right__img__Nsvlt`,
	"underTitle": `Main_underTitle__4iNGg`,
	"wrap": `Main_wrap__Sz3qQ`,
	"wrap__right": `Main_wrap__right__yfLlN`,
	"under__photo": `Main_under__photo__RquAe`,
	"under__photo__deliv": `Main_under__photo__deliv__imCEZ`
};
export default ___CSS_LOADER_EXPORT___;
